import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { getAnalytics } from "firebase/analytics"; // Временно отключаем analytics
import { notificationsService } from "../api/notifications";

// Конфигурация Firebase из переменных окружения
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Инициализация Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); // Временно отключаем analytics
const messaging = getMessaging(app);

// Функция для отправки Firebase токена на бэкенд
const sendTokenToServer = async (token) => {
  try {
    // Сохраняем токен локально для отладки
    localStorage.setItem("firebaseToken", token);

    // Пытаемся отправить на бэкенд
    try {
      await notificationsService.registerToken(token);
    } catch (backendError) {
      // Тихо игнорируем ошибки бэкенда - токен сохранен локально
    }

    return true;
  } catch (error) {
    console.error("Error in sendTokenToServer:", error);
    throw error;
  }
};

// Регистрация Service Worker
const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      // Проверяем, есть ли уже зарегистрированный Service Worker
      const existingRegistration =
        await navigator.serviceWorker.getRegistration(
          "/firebase-messaging-sw.js"
        );

      if (!existingRegistration) {
        await navigator.serviceWorker.register("/firebase-messaging-sw.js");

        // Ждем активации Service Worker
        await navigator.serviceWorker.ready;
      } else {
        // Убеждаемся, что Service Worker активен
        await navigator.serviceWorker.ready;
      }

      return true;
    } catch (error) {
      console.error("Ошибка регистрации Service Worker:", error);
      throw error;
    }
  } else {
    throw new Error("Service Worker не поддерживается браузером");
  }
};

// Запрос разрешения на отправку уведомлений
export const requestNotificationPermission = async () => {
  try {
    // Проверяем, есть ли уже сохраненный токен
    const existingToken = localStorage.getItem("firebaseToken");
    if (existingToken) {
      return existingToken;
    }

    // Сначала регистрируем Service Worker
    await registerServiceWorker();

    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // Получаем токен с VAPID ключом из переменных окружения
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      });
      await sendTokenToServer(token);
      return token;
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    throw error;
  }
};

// Обработчик входящих сообщений
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

// Экспортируем функцию регистрации Service Worker для использования в других компонентах
export { registerServiceWorker };

export default app;
